import { handlePlaySound } from '@handlers/handlePlaySound'
import { handleTriggerAnimation } from '@shared'

export function handleMatchOutcome () {
  handlePlaySound('match')
  handleTriggerAnimation('match')
}
